




























import Vue from "vue";
import { locStr } from "@/utilities";
export default Vue.extend({
    name: "MangoFpEditProcess",
    props: {
        state: {
            type: Object,
            required: true,
        },

        allStates: {
            type: Array,
            required: true,
        },
        showLoader: {
            type: Boolean,
        },
    },
    data() {
        return {
            next4Edit: [...this.state.next],
            absolute: true,
        };
    },
    methods: {
        locStr: function(key: string): string {
            return locStr(key);
        },
        saveData() {
            this.$emit("add", {
                code: this.state.code,
                next: this.next4Edit,
            });
        },
        cancelSaving() {
            this.next4Edit = [...this.state.next];
            this.$emit("close");
        },
    },
});
